import React from "react";
import { StaticPageQuery } from "components/StaticPageTemplate";
import StaticPageContent from "components/StaticPageTemplate/StaticPageContent";
import Layout from "components/common/Layout";
import { SeoPageProps } from "helpers/seo";

interface NestedStaticPageRouteProps {
  seo: SeoPageProps["seo"];
  staticPage?: StaticPageQuery["page"];
}

const NestedStaticPageRoute = ({ seo, staticPage }: NestedStaticPageRouteProps) => {
  if (!staticPage) {
    return <Layout initialMeta={seo} />;
  }

  return (
    <Layout initialMeta={seo}>
      <StaticPageContent page={staticPage} />
    </Layout>
  );
};

export default NestedStaticPageRoute;
